import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useNewsData } from '../../hooks/useNewsData';
import { newsDateConverter, getNewsCategory } from '../../components/converter';
import '../../styles/components/NewsCard.css';
import './NewsPage.css';

const INITIAL_COUNT = 9;
const LOAD_STEP = 9;

const NewsPage = () => {
    const { news, isLoading } = useNewsData();
    const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);

    if (isLoading) {
        return <p>Loading news...</p>;
    }

    const featured = news[0];
    const featuredCategory = getNewsCategory(featured);
    const rest = news.slice(1);
    const shownCount = Math.min(visibleCount, rest.length);
    const visibleNews = rest.slice(0, shownCount);
    const hasMore = shownCount < rest.length;

    return (
        <div className="news-page">
            <div className='header-banner'>
                <h1>NEUES</h1>
            </div>
            <div className="news-page__container">
                <NavLink className="news-card news-featured" to={`${featured.slug}`}>
                    <div className="news-featured__text">
                        {featuredCategory && <span className="news-card__tag">{featuredCategory}</span>}
                        <h2 className="news-featured__title">{featured.title}</h2>
                        <div className="news-card__footer">
                            <div className="news-card__divider"/>
                            <span className="news-card__meta">{newsDateConverter(featured.publishedAt)} &nbsp;·&nbsp; {featured.readTime}</span>
                        </div>
                    </div>
                    <div className="news-featured__media">
                        <img src={featured.img} alt="Artikel Bild" loading="lazy"/>
                    </div>
                </NavLink>

                <div className="news-page__grid">
                    {visibleNews.map(item => {
                        const category = getNewsCategory(item);
                        return (
                            <NavLink key={item.id} className="news-card" to={`${item.slug}`}>
                                <div className="news-card__media">
                                    <img src={item.img} alt="Artikel Bild" loading="lazy"/>
                                </div>
                                <div className="news-card__body">
                                    {category && <span className="news-card__tag">{category}</span>}
                                    <h3 className="news-card__title">{item.title}</h3>
                                    <div className="news-card__footer">
                                        <div className="news-card__divider"/>
                                        <span className="news-card__meta">{newsDateConverter(item.publishedAt)} &nbsp;·&nbsp; {item.readTime}</span>
                                    </div>
                                </div>
                            </NavLink>
                        );
                    })}
                </div>

                <div className="news-page__load-more">
                    {hasMore && (
                        <button
                            className="news-page__load-more-button"
                            onClick={() => setVisibleCount(shownCount + LOAD_STEP)}
                        >
                            Mehr laden
                        </button>
                    )}
                    <span className="news-page__load-more-label">{1 + shownCount} von {news.length} Artikeln</span>
                </div>
            </div>
        </div>
    );
}

export default NewsPage;
